const SET_TEAM_ID_KEY = 'SET_TEAM_ID';

const serviceWorkerSharedData = {
  teamId: '',
};

const setTeamId = (teamId: string) => {
  serviceWorkerSharedData.teamId = teamId;
};

self.addEventListener('message', (event) => {
  const { type, teamId } = event.data || {};
  if (type === SET_TEAM_ID_KEY) {
    setTeamId(teamId);
  }
});

const updateTeamIdInSW = (teamId: string): void => {
  if (navigator.serviceWorker && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: SET_TEAM_ID_KEY,
      teamId,
    });
  } else {
    console.warn('service worker não está ativo ou não há controller disponível');
  }
};

export { serviceWorkerSharedData, updateTeamIdInSW };
